<script lang="ts">
	import * as m from '$lib/paraglide/messages';
	import { Seo } from '$lib/ui/atoms/Seo';
	import { wikiCategoryLabel } from '$lib/features/wiki/logic/category-labels';
	import { wikiHref } from '$lib/features/wiki/logic/wiki-index';

	let { data } = $props();
</script>

<Seo
	title={m.wiki_title()}
	description={m.wiki_intro()}
	canonicalPath={wikiHref(data.locale)}
	hreflang={data.translations}
/>

<h1 class="wiki-home-title">{m.wiki_title()}</h1>
<p class="wiki-home-intro">{m.wiki_intro()}</p>

{#each data.sidebar as section (section.category)}
	<section class="wiki-home-section">
		<h2>{wikiCategoryLabel(section.category)}</h2>
		<ul>
			{#each section.items as item (item.pageId)}
				<li>
					<a href={item.href}>{item.title}</a>
					{#if item.fallback}<span class="lang-chip">EN</span>{/if}
				</li>
			{/each}
		</ul>
	</section>
{/each}

<style>
	.wiki-home-title {
		font-size: 2rem;
		font-weight: 800;
		letter-spacing: -0.02em;
		margin: 0 0 0.5rem;
		color: var(--v3-text);
	}
	.wiki-home-intro {
		color: var(--v3-muted);
		margin: 0 0 2rem;
		max-width: 60ch;
	}
	.wiki-home-section {
		margin-bottom: 2rem;
	}
	.wiki-home-section h2 {
		font-size: 0.8rem;
		font-weight: 700;
		letter-spacing: 0.08em;
		text-transform: uppercase;
		color: var(--v3-muted);
		margin: 0 0 0.75rem;
	}
	.wiki-home-section ul {
		list-style: none;
		margin: 0;
		padding: 0;
		display: flex;
		flex-direction: column;
		gap: 0.35rem;
	}
	.wiki-home-section a {
		color: var(--v3-text);
		font-weight: 600;
		text-decoration: none;
	}
	.wiki-home-section a:hover {
		text-decoration: underline;
	}
	.lang-chip {
		font-size: 0.62rem;
		font-weight: 700;
		letter-spacing: 0.06em;
		color: var(--v3-muted);
		border: 1px solid var(--v3-border);
		border-radius: 9999px;
		padding: 0.05rem 0.4rem;
		margin-left: 0.4rem;
	}
</style>
